import React, { useEffect, useState } from 'react';
import Api, { exceptionNotificationAPI } from '../../services/api';
import FormCrud from '../../components/FormCrud';

const OperationForm = () => {
    const [reportOptions, setReportOptions] = useState(null);
    const [companysOptions, setCompanysOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const activeOptions = [
        { value: true, text: "Yes" },
        { value: false, text: "No" }
    ];

    const fields = [
        {
            label: "Report Year",
            name: "reportYearID",
            type: "select",
            options: reportOptions
        },
        {
            label: "Form Description",
            name: "description",
            type: "input"
        },
        {
            label: "Guidance",
            name: "guidance",
            type: "textarea",
            required: false
        },
        {
            label: "Order",
            name: "order",
            type: "number"
        },
        {
            label: "Companies to exclude",
            name: "operationCompany",
            type: "select",
            required: false,
            options: companysOptions,
            multiple: true
        },
        {
            label: "Is Active",
            name: "isActive",
            type: "select",
            options: activeOptions
        },
    ];

    const loadReportYear = async (cultureID) => {
        try {
            const result = await Api.get(`Culture/getAllReportYearsByCulture?cultureID=${cultureID}`);
            if (result?.data?.response?.reportYears) {
                const options = result.data.response.reportYears.map(item => ({ 
                    value: item.reportYearID, 
                    text: `${item.year}` 
                }));
                setReportOptions(options);
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    }

    const loadCompanies = async (cultureID) => {
        try {
            const result = await Api.get(`Company/getAllByCulture?cultureID=${cultureID}`);
            if (result?.data?.response) {
                const options = result.data.response.map(item => ({ 
                    value: item.companyID, 
                    text: `${item.name}` 
                }));
                setCompanysOptions(options);
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    }

    useEffect(() => {
        async function load() {
            const userLogged = JSON.parse(localStorage.getItem('@Thrive:user'));
            
            if (userLogged?.selectedCultureID) {
                await Promise.all([
                    loadReportYear(userLogged.selectedCultureID),
                    loadCompanies(userLogged.selectedCultureID)
                ]);
            }
            
            setIsLoading(false);
        }
        load();
    }, []);

    return (
        <FormCrud 
            formName={"operation"} 
            title={"Form"} 
            fields={fields} 
        />
    );
}

export default OperationForm;